"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _classes = _interopRequireDefault(require("@nerdwallet/base-styles/classes"));

var _loadingCoinModule = _interopRequireDefault(require("./loading-coin.module.less"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var LoadingCoin = function LoadingCoin(_ref) {
  var className = _ref.className;
  return _react["default"].createElement("div", null, _react["default"].createElement("span", {
    className: (0, _classes["default"])('screen-reader-only')
  }, "Loading..."), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].coin, className),
    "aria-hidden": "true"
  }, _react["default"].createElement("div", {
    className: _loadingCoinModule["default"].scene
  }, _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].shape, _loadingCoinModule["default"].cylinder)
  }, _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].bottom)
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].top)
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-0'])
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-1'])
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-2'])
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-3'])
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-4'])
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-5'])
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-6'])
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-7'])
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-8'])
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-9'])
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-10'])
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-11'])
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-12'])
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-13'])
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-14'])
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-15'])
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-16'])
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-17'])
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-18'])
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-19'])
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-20'])
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-21'])
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-22'])
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-23'])
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-24'])
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-25'])
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-26'])
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-27'])
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-28'])
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_loadingCoinModule["default"].face, _loadingCoinModule["default"].side, _loadingCoinModule["default"]['side-29'])
  })))));
};

LoadingCoin.propTypes = {
  className: _propTypes["default"].string
};
LoadingCoin.defaultProps = {
  className: null
};
var _default = LoadingCoin;
exports["default"] = _default;